/* eslint-disable global-require, @typescript-eslint/no-var-requires, no-underscore-dangle,import/no-extraneous-dependencies,import/no-import-module-exports */
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { MOUNT_NODE_ID } from '@is24at/react-constants';
import createStore from 'store/createStore';
import App from './components/App';

/**
 * Use the `useHMR` setting in `project.config.local.js` or the `NO_HMR`
 * env variable to control the `module.hot` behavior during development.
 */

const shouldEnableHMR = __DEV__ && module.hot;

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.__INITIAL_STATE__;
const store = createStore(initialState);

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById(MOUNT_NODE_ID) as HTMLElement;

if (!(MOUNT_NODE instanceof HTMLElement)) {
  throw new Error('Unable to select mount node');
}

const render = (NextApp: any) => {
  if (shouldEnableHMR) {
    module.hot?.accept(['./components/App', './routes/index'], () =>
      render(App),
    );
  }

  const routes = require('./routes').default;

  hydrateRoot(MOUNT_NODE, <NextApp store={store} routes={routes} />);
};

// ========================================================
// Go!
// ========================================================
render(App);
